module.exports = __webpack_public_path__ + "img/Trupp.f30b1ba9.svg";